<template>
    <section v-if="json" class="page-search">
        <div v-if="showMessage" class="messages">
            <div class="capper" v-if="isSearching">
                <div class="capper-padded">
                    <div class="rte no-max-width">
                        <p>Please wait...</p>
                    </div>
                </div>
            </div>
            <div class="capper" v-else>
                <div class="capper-padded">
                    <div class="rte no-max-width">
                        <h1>{{json.title}}</h1>
                        <p><span v-html="textResultsLine"></span></p>
                        <div v-if="showMessage === 'search'" class="copy" v-html="json.enterYourSearch"></div>
                        <div v-if="showMessage === 'results'" class="copy" v-html="json.noResults"></div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="results">
            <FilterSet />
            <div class="capper" v-if="isSearching">
                <div class="capper-padded results-wait">
                    <div class="rte no-max-width">
                        <p>Please wait...</p>
                    </div>
                </div>
            </div>
            <div class="capper" v-if="!isSearching">
                <div class="capper-padded">
                    <div class="results-line">
                        <span v-html="textResultsLine"></span>
                    </div>
                    <div class="search-grid">
                        <div
                            v-for="(item, index) in filteredJson"
                            class="grid-item-outer"
                            :key="`griditem${Math.random()}${index}`"
                        >
                            <div class="grid-item">
                                <router-link v-if="item.url" :to="item.url">
                                    <div data-aos="custom-fade-in" class="bgimg" :style="getStyle(item)"></div>
                                </router-link>
                                <div v-else data-aos="custom-fade-in" class="bgimg" :style="getStyle(item)"></div>
                            </div>
                            <div class="grid-item-title">
                                <router-link v-if="item.url" :to="item.url">{{ item.title }}</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from "axios";
import gh from "@/helpers/gh";
import { mapState } from "vuex";
import FilterSet from "@/components/blocks/FilterSet.vue";

export default {
    name: "WorkPage",
    components: {
        FilterSet,
    },
    data() {
        return {
            window: window,
            json: null,
            results: [],
            globalJson: null,
            transition: false,
            filterToggler: Math.random(),
            isSearching: false,
        };
    },
    mounted() {
        const newSearchTerm = this.$route.query.q;
        if (newSearchTerm) {
            this.$store.commit("setSearchTerm", newSearchTerm);
            this.searchTerm = newSearchTerm;
        } else {
            this.searchTerm = this.$route.state?.searchTerm || "";
        }

        if (this.searchTerm) {
            this.updateUrl(this.searchTerm);
            this.doSearch(this.searchTerm);
        }

        let slug = this.$route.fullPath;
        slug = gh.stripSlashesFrontAndBack(slug);
        axios
            .get(`${window.config.apiroot}${slug}/${window.config.craftApiPreviewToken}`)
            .then((res) => {
                this.json = res.data;
                this.reveal();
            })
            .catch((e) => {
                console.error("Error", slug, e);
            });
    },
    watch: {
        searchTerm(newTerm) {
            this.updateUrl(newTerm);
            this.doSearch(newTerm);
        },
        selectedFilters: {
            handler() {
                this.filterToggler = Math.random();
            },
            deep: true,
        },
    },
    computed: {
        ...mapState({
            searchTerm: (state) => state.searchTerm,
            selectedFilters: (state) => state.selectedFilters,
        }),
        showMessage() {
            let ret = false;
            if (this.filterToggler) {
                if (!this.searchTerm) {
                    ret = "search";
                } else if (!this.results || this.results.length === 0) {
                    ret = "results";
                }
            }
            return ret;
        },
        filteredJson() {
            if (!this.filterToggler) {
                return this.results;
            }

            if (!this.selectedFilters || this.selectedFilters.length === 0) {
                return this.results;
            }

            return this.results.filter((item) => {
                if (!item.projectCategory || !Array.isArray(item.projectCategory)) {
                    return false;
                }

                // MATCHES ANY
                // return item.projectCategory.some((category) =>
                //     this.selectedFilters.some((filter) => filter.slug === category.slug)
                // );

                // MATCHES ALL
                const catSlugs = item.projectCategory.map(cat => cat.slug);
                return this.selectedFilters.every(filter => catSlugs.includes(filter.slug));
            });
        },
        textResultsLine() {
            let ret = "";
            if (this.searchTerm && this.filterToggler) {
                const len = this.filteredJson.length;
                const s = len === 1 ? "" : "s";
                const filtered = this.selectedFilters.length > 0 ? "filtered" : "";
                ret = `${len} ${filtered} result${s} for ` + this.searchTerm;
            }
            return ret;
        },
    },
    methods: {
        getStyle(item) {
            if (item.poster?.[0]) {
                const poster = item.poster[0];
                return `background-image: url(${poster.url});${poster.bgStyle}`;
            }
            return "";
        },
        reveal() {
        },
        unreveal() {
        },
        doSearch(term) {
            if (term) {
                this.isSearching = true;
                axios
                    .get(`${window.config.apirootActions}search?q=${term}`)
                    .then((response) => {
                        this.results = response.data.data;
                        this.filterToggler = Math.random();
                        this.isSearching = false;
                    })
                    .catch((error) => {
                        console.error("Search Error:", error);
                        this.filterToggler = Math.random();
                        this.isSearching = false;
                    });
            } else {
                this.filterToggler = Math.random();
                this.isSearching = false;
            }
        },
        updateUrl(term) {
            const currentQuery = { ...this.$route.query }; // Get the current query parameters

            if (term) {
                currentQuery.q = term; // Update or add the `q` parameter
            } else {
                delete currentQuery.q; // Remove the `q` parameter if `term` is empty
            }

            // Replace the URL with the updated query parameters
            this.$router.replace({ query: currentQuery }).catch((err) => {
                if (err.name !== "NavigationDuplicated") {
                    console.error(err);
                }
            });
        },
    },
};
</script>
